import { Component, ChangeDetectionStrategy } from '@angular/core';
import { APP } from '../../core/constants/app.constants';

@Component({
    selector: 'dmp-status-bar',
    templateUrl: './status-bar.component.html',
    styleUrls: ['./status-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StatusBarComponent {
  readonly version = APP.VERSION;
}
